import React, {useCallback, useEffect, useState} from "react"
import { IconButton, Snackbar, SnackbarContent} from "@material-ui/core"
import {Alert as MuiAlert} from '@material-ui/lab';
import {green, amber} from "@material-ui/core/colors"
import CloseIcon from "@material-ui/icons/Close"

export enum WARNING_SEVERITY {
	RED = "error",
	YELLOW = "warning",
	BLUE = "info",
	GREEN = "success",
}

export interface AlertPorps {
	message: string
	title: string
	open: boolean
	color: string
}
const Alert = React.forwardRef<HTMLDivElement, any>(function Alert(props, ref) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

export const AlertWithStatus = (props: AlertPorps) => {
	const [open, setOpen] = useState(props.open)

	const getBackgroundColor = () => {
		switch (props.color) {
			case WARNING_SEVERITY.RED:
				return "#d32f2f"
			case WARNING_SEVERITY.GREEN:
				return green[600]
			case WARNING_SEVERITY.BLUE:
				return "42a5f5"
			case WARNING_SEVERITY.YELLOW:
				return amber[700]
			default:
				return "white"
		}
	}

	const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === "clickaway") {
			return
		}
		setOpen(false)
	}
	const getAlert = useCallback(() => {
		setOpen(props.open)
	}, [props.open])
	useEffect(() => {
		getAlert()
	}, [getAlert])

	return (
		<Snackbar
			autoHideDuration={11000}
			onClose={handleClose}
			anchorOrigin={{vertical: "top", horizontal: "center"}}
			open={open}
			color={props.color}
		>
			<SnackbarContent
				aria-describedby="client-snackbar"
				style={{
					backgroundColor: getBackgroundColor(),
					paddingTop: 0,
					paddingBottom: 0,
					marginTop: 0,
					marginBottom: 0,
				}}
				message={
					<Alert
						key={props.message + props.color}
						severity={props.color}
						style={{boxShadow: "none"}}
					>
						{props.message}
					</Alert>
				}
				action={[
					<IconButton key="close" aria-label="Close" color={"inherit"} onClick={handleClose}>
						<CloseIcon />
					</IconButton>,
				]}
			/>
		</Snackbar>
	)
}
